import(/* webpackMode: "eager" */ "/vercel/path0/app/products/[slug]/page.tsx");
